module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-grouth.37de63e1.png";